import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { Alert, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useApiHook from "../../hooks/useApiHook";
import { usePatientRefresh, useRenamePatientModal } from "../../store/modal-context";
import ResponsiveDialog from "../_atoms/ResponsiveDialog";
import cancelButtonSx from "../../styles/cancelButtonSx";

const RenamePatientDialog = () => {
    const { isOpen, closeModal, payload } = useRenamePatientModal();
    const { refreshPatients } = usePatientRefresh();
    const { response, makeRequest, loading, error } = useApiHook();
    const [patientName, setPatientName] = useState("");
    const [submitRequested, setSubmitRequested] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        setPatientName(payload?.patientName || "");
        setSubmitRequested(false);
    }, [isOpen, payload?.patientName]);

    useEffect(() => {
        if (!isOpen || !submitRequested || !response || response.state !== 'success') {
            return;
        }

        refreshPatients();
        if (payload?.onSuccess) {
            payload.onSuccess(response.data);
        }

        setSubmitRequested(false);
        closeModal();
    }, [closeModal, isOpen, payload, refreshPatients, response, submitRequested]);

    const onConfirmHandler = () => {
        const trimmedPatientName = patientName.trim();
        if (!trimmedPatientName || !payload?.patientId) {
            return;
        }

        setSubmitRequested(true);
        makeRequest('/folder/rename', 'post', {
            folderId: payload.patientId,
            name: trimmedPatientName
        });
    };

    return (
        <ResponsiveDialog
            minWidth="unset"
            minHeight="unset"
            title={(
                <Stack direction="row" alignItems="center" spacing={1}>
                    <DriveFileRenameOutlineIcon fontSize="large" />
                    <Typography variant="h5">Rinomina paziente</Typography>
                </Stack>
            )}
            isOpen={isOpen}
            onClose={closeModal}
            actions={(
                <>
                    <Button
                        size="large"
                        variant="contained"
                        onClick={onConfirmHandler}
                        disabled={loading || !patientName.trim()}
                    >
                        Rinomina
                    </Button>
                    <Button size="large" variant="outlined" onClick={closeModal} sx={cancelButtonSx}>
                        Annulla
                    </Button>
                </>
            )}
        >
            <Stack width="100%" spacing={2}>
                <Typography width="100%" textAlign="left" variant="body2" sx={{ opacity: 0.65 }}>
                    Inserisci il nuovo nome del paziente.
                </Typography>
                {error && (
                    <Alert severity="error">
                        Impossibile rinominare il paziente. Riprova.
                    </Alert>
                )}
                <TextField
                    autoFocus
                    fullWidth
                    label="Nome paziente"
                    value={patientName}
                    onChange={(event) => setPatientName(event.target.value)}
                />
            </Stack>
        </ResponsiveDialog>
    );
};

export default RenamePatientDialog;
